import { Outlet, RouterProvider } from "react-router-dom";
import { connect } from "react-redux";
import routes from "./routes";
import Loader from "./components/Loader";

function App(props: any) {
  const { updateLoading: { isLoading = false } = {} } = props;
  return (
    <div className="App">
      {isLoading ? <Loader /> : null}
      <RouterProvider router={routes} />
    </div>
  );
}

const mapDispatchToProps = {};
const mapStateToProps = (state: any) => ({
  updateLoading: state.loader,
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
